import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import Heading from '../UI/Texts/Heading';
import ArticuloItem from '../MostrarArticulos/articuloItem';
import './styles.css';

const ProductosRelacionadosCarousel = ({
    productosAsociados,
    instalacion,
    usuario,
    configVidriera,
    pedido,
    agregarQuitarUnidad
}) => {
    const listRef = useRef(null);
    const [productosVisibles, setProductosVisibles] = useState(productosAsociados || []);

    useEffect(() => {
        setProductosVisibles(productosAsociados || []);
    }, [productosAsociados]);

    const scroll = (direction) => {
        if (listRef.current) {
            const { scrollLeft, clientWidth } = listRef.current;
            const scrollAmount = clientWidth * 0.8; // Scroll 80% of width
            const scrollTo = direction === 'left' ? scrollLeft - scrollAmount : scrollLeft + scrollAmount;
            listRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
    };

    // Si no hay productos, no renderizamos nada
    if (!productosVisibles || productosVisibles.length === 0) {
        return null;
    }

    return (
        <div className="productosRelacionadosContainer">
            <Row>
                <Col xs={12}>
                    <Heading tag="h2" weight="bold" className="relacionadosTitulo">
                        También podría interesarte...
                    </Heading>
                </Col>
            </Row>
            
            <div className="relacionadosCarouselContainer">
                {productosVisibles.length > 1 && (
                    <button className="carouselNavBtn prev" onClick={() => scroll('left')} aria-label="Anterior">
                        &#10094;
                    </button>
                )}
                
                <ul 
                    className="relacionadosCarouselList" 
                    ref={listRef}
                    style={{ 
                        justifyContent: productosVisibles.length < 4 ? 'center' : 'flex-start' 
                    }}
                >
                    {productosVisibles.map((articulo, index) => {
                        // Determinamos cantidad inicial si hay pedido
                        let cantidadInicial = 0;
                        if (pedido && pedido.listaPedidoDetalle) {
                            const detalle = pedido.listaPedidoDetalle.find(x => x.idArticulo === articulo.idArticulo);
                            if (detalle) {
                                cantidadInicial = detalle.cantidad;
                            }
                        }

                        return (
                            <li key={articulo.idArticulo || index} className="relacionadosCarouselItem">
                                <ArticuloItem
                                    item={articulo}
                                    instalacion={instalacion}
                                    usuario={usuario}
                                    pedido={pedido}
                                    configVidriera={configVidriera}
                                    cantidadInicial={cantidadInicial}
                                    agregarQuitarUnidad={agregarQuitarUnidad}
                                    precioListaPedido={{}}
                                    getBandaDePreciosCasoDos={() => {}}
                                    imagenes={{}}
                                    handleOnButtonPedilo={() => {}}
                                    handleOnBorrar={() => {}}
                                    hideQuantitySelector={true}
                                    mostrarPrecioEnRelacionados={true}
                                />
                            </li>
                        );
                    })}
                </ul>

                {productosVisibles.length > 1 && (
                    <button className="carouselNavBtn next" onClick={() => scroll('right')} aria-label="Siguiente">
                        &#10095;
                    </button>
                )}
            </div>
        </div>
    );
};

export default ProductosRelacionadosCarousel;
